export interface GroupOwnerDto {
  GroupOwnerID: string;
  TradeGroupID: string;
  HRRef: number | null;
  Owner: string;
  bActive: boolean;
  VPCompanyIDs: number[];
  Tier: number | null;

  /** Client side only */
  isDirty: boolean;
}
